export default __webpack_public_path__ + "static/media/fifa2.6c17656a.png";